var convertToUnit = function (str, unit) {
    if (unit === void 0) { unit = 'px'; }
    if (str == null || str === '') {
        return undefined;
    }
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(+str)) {
        return String(str);
    }
    return "" + Number(str) + unit;
};
export var useMeasure = function (props) {
    var style = {
        height: convertToUnit(props.height),
        maxHeight: convertToUnit(props.maxHeight),
        minHeight: convertToUnit(props.minHeight),
        width: convertToUnit(props.width),
        maxWidth: convertToUnit(props.maxWidth),
        minWidth: convertToUnit(props.minWidth),
    };
    return { style: style };
};
